import { create } from 'zustand';

const initialState = {
  email: null,
  signupMethod: null,
  isVerified: null,
  country: null,
  moneyType: null,
  displayName: null,
  icon: null,
  linkId: null
};

export const useUserStore = create((set) => ({
  ...initialState,
  
  setEmail: (email) => set({ email }),
  setSignupMethod: (signupMethod) => set({ signupMethod }),
  setIsVerified: (isVerified) => set({ isVerified }),
  setUserCountry: (country) => set({ country }),
  setMoneyType: (moneyType) => set({ moneyType }),
  setDisplayName: (displayName) => set({ displayName }),
  setUserIcon: (icon) => set({ icon }),
  setLinkId: (linkId) => set({ linkId }),
  resetUser: () => set(initialState)
}));

// User state selectors
export const useEmail = () => useUserStore(state => state.email);
export const useSignupMethod = () => useUserStore(state => state.signupMethod);
export const useIsVerified = () => useUserStore(state => state.isVerified);
export const useUserCountry = () => useUserStore(state => state.country);
export const useMoneyType = () => useUserStore(state => state.moneyType);
export const useDisplayName = () => useUserStore(state => state.displayName);
export const useUserIcon = () => useUserStore(state => state.icon);
export const useLinkId = () => useUserStore(state => state.linkId);

// User state setter hooks
export const useSetEmail = () => useUserStore(state => state.setEmail);
export const useSetSignupMethod = () => useUserStore(state => state.setSignupMethod);
export const useSetIsVerified = () => useUserStore(state => state.setIsVerified);
export const useSetUserCountry = () => useUserStore(state => state.setUserCountry);
export const useSetMoneyType = () => useUserStore(state => state.setMoneyType);
export const useSetDisplayName = () => useUserStore(state => state.setDisplayName);
export const useSetUserIcon = () => useUserStore(state => state.setUserIcon);
export const useSetLinkId = () => useUserStore(state => state.setLinkId);
export const useResetUser = () => useUserStore(state => state.resetUser);
